var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlayArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    viewBox: "0 0 3118.6599 3527.7775",
    id: "svg127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-239.83,-35.2725)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    d: "m 239.83,258.0425 c 0,122.5 100.27,222.78 222.77,222.78 h 2673.12 c 122.5,0 222.77,-100.28 222.77,-222.78 0,-122.5 -100.27,-222.77 -222.77,-222.77 H 462.6 c -122.5,0 -222.77,100.27 -222.77,222.77 z m 2581.8,1836.52 h -354.19 v -1113.78 c 0,-122.5 -100.28,-222.77 -222.78,-222.77 l -891.01,0.08 c -122.5,0 -222.77,100.27 -222.77,222.77 v 1113.79 l -354.11,-0.09 c -198.28,0 -298.47,240.63 -158.2,380.89 L 1641,3497.8825 c 86.89,86.89 227.24,86.89 314.12,0 l 1022.44,-1022.43 c 140.35,-140.35 42.35,-380.89 -155.93,-380.89 z",
    id: "path124"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayArrowDown);
export default __webpack_public_path__ + "static/media/icon-play-arrow-down.ec79da7c18836a9e0a39b0b8bd629618.svg";
export { ForwardRef as ReactComponent };